import { createFileRoute } from '@tanstack/react-router'
import { Monitor } from 'lucide-react'
import { useLogout } from '@/hooks/use-logout'

/**
 * Les rôles `admin` et `super_admin` n'ont accès à aucun contrôleur métier
 * (tous décorés `@Roles('pastor', 'secretary', …)`) : leur ouvrir l'espace
 * staff ne produirait que des 403. On les renvoie vers le tableau de bord web.
 */
export const Route = createFileRoute('/espace-indisponible')({
  component: UnavailableSpace,
})

function UnavailableSpace() {
  const logout = useLogout()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-5 bg-navy-950 px-8 text-center pt-safe pb-safe">
      <div className="flex h-16 w-16 items-center justify-center rounded-[20px] border border-gold/30 bg-gold/10">
        <Monitor size={30} color="#C9A84C" aria-hidden="true" />
      </div>

      <div>
        <h1 className="text-[22px] font-bold text-chalk">Espace non disponible sur mobile</h1>
        <p className="mt-2 text-[14px] leading-relaxed text-steel">
          L'administration de la plateforme se gère depuis le tableau de bord web, sur ordinateur.
        </p>
      </div>

      <button
        type="button"
        onClick={logout}
        className="mt-2 rounded-[14px] border border-navy-800 px-6 py-3 text-[15px] font-semibold text-danger"
      >
        Se déconnecter
      </button>
    </div>
  )
}
